import { streemLogger } from '../util/streem_logger';
import { getPermissionsState } from '../util/permission_state';
import { BehaviorSubject } from 'rxjs';
export class ChimeDeviceObserver {
    constructor(onLocalDevicesChanged, initialAudioInputDevices, initialAudioOutputDevices, initialVideoInputDevices) {
        this.logger = streemLogger.extend('sdk-chime-video:ChimeDeviceObserver');
        this.getUserMediaVideoErrorSubject = new BehaviorSubject(undefined);
        this.getUserMediaVideoError = this.getUserMediaVideoErrorSubject.asObservable();
        this.getUserMediaAudioErrorSubject = new BehaviorSubject(undefined);
        this.getUserMediaAudioError = this.getUserMediaAudioErrorSubject.asObservable();
        this.onLocalDevicesChanged = onLocalDevicesChanged;
        this.audioInputs = initialAudioInputDevices;
        this.audioOutputs = initialAudioOutputDevices;
        this.videoInputs = initialVideoInputDevices;
        this.onLocalDevicesChanged(this.getLocalDevices());
    }
    get audioOutputDevices() {
        return this.audioOutputs;
    }
    get audioInputDevices() {
        return this.audioInputs;
    }
    get videoInputDevices() {
        return this.videoInputs;
    }
    getLocalDevices() {
        return [...this.audioInputs, ...this.audioOutputs, ...this.videoInputs];
    }
    audioInputsChanged(freshAudioInputDevices) {
        this.audioInputs = freshAudioInputDevices;
        this.onLocalDevicesChanged(this.getLocalDevices());
    }
    audioOutputsChanged(freshAudioOutputDevices) {
        this.audioOutputs = freshAudioOutputDevices;
        this.onLocalDevicesChanged(this.getLocalDevices());
    }
    videoInputsChanged(freshVideoInputDevices) {
        this.videoInputs = freshVideoInputDevices;
        this.onLocalDevicesChanged(this.getLocalDevices());
    }
    async videoInputStreamEnded(deviceId) {
        this.logger.info(`Video input stream ended for device: ${deviceId}`);
        const permissionState = await getPermissionsState();
        if (permissionState.camera === 'denied') {
            this.logger.warn(`Camera permission state: ${permissionState.camera}`);
            this.getUserMediaVideoErrorSubject.next('NotAllowedError');
        }
    }
    async audioInputStreamEnded(deviceId) {
        this.logger.info(`Audio input stream ended for device: ${deviceId}`);
        const permissionState = await getPermissionsState();
        if (permissionState.microphone === 'denied') {
            this.logger.warn(`Microphone permission state: ${permissionState.microphone}`);
            this.getUserMediaAudioErrorSubject.next('NotAllowedError');
        }
    }
}
//# sourceMappingURL=chime_device_observer.js.map